import React, { useState, useEffect } from 'react';
import useFetch from "../../services/useFetch.js"
import MetricCard from '../ui/MetricCard';

export default function TotInventory({ startDate, endDate, reload, showLoad }) {
    const [val, setVal] = useState(null);
    const apiUrl = `api/inventory-cost?startDateStr=${startDate}&endDateStr=${endDate}`;
    const { data, load } = useFetch(apiUrl, reload);

    useEffect(() => {
        if (data == null) return;
        showLoad?.();
        setVal(data.sumInventoryCost);
    }, [data]);

    return (
        <MetricCard
            label="Inventory sum cost"
            loading={load}
            value={val != null && val !== 0 ? `$${Number(val).toFixed(2)}` : '—'}
            detail={val ? 'Across selected dates' : 'No data for dates'}
        />
    );
}
